import React, { useState } from "react";
import { useCheckout } from "../../providers/CheckoutProvider";
import UpsaleDialogCatalogue from "./UpsaleDialogCatalogue";
import UpsaleDialogDigitalFiles from "./UpsaleDialogDigitalFiles";

export default () => {
  const { upsaleList } = useCheckout();
  const [currentStep, setCurrentStep] = useState(0);

  const handleNextStep = () => {
    setCurrentStep((currentStep) => currentStep + 1);
  };

  console.log("Current step", currentStep, upsaleList);

  if (!upsaleList || currentStep == upsaleList.length) {
    return null;
  }

  switch (upsaleList[currentStep].type) {
    case "CATALOGUE":
      return <UpsaleDialogCatalogue handleNextStep={handleNextStep} />;
    case "DIGITAL_FILES":
      return (
        <UpsaleDialogDigitalFiles
          handleNextStep={handleNextStep}
          {...upsaleList[currentStep]}
        />
      );
  }
  return <div>hello</div>;
};
